import Vue from 'vue';
import App from '@/App.vue';

import router from '@/router';
import store from '@/store';

import { VueHammer } from 'vue2-hammer';

// import VueHtml2Canvas from 'vue-html2canvas';
// Vue.use(VueHtml2Canvas);
import VueScrollTo from 'vue-scrollto';

import loading from '@/plugins/loading';
import toast from '@/plugins/toast';
import modal from '@/plugins/modal';
import sheet from '@/plugins/sheet';
import preview from '@/plugins/preview';

Vue.use(VueHammer);
Vue.use(VueScrollTo, {
    container: 'body',
    duration: 400,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});
Vue.use(loading);
Vue.use(toast);
Vue.use(modal);
Vue.use(sheet);
Vue.use(preview);

Vue.config.productionTip = false;

const vue = new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');

export default vue;
